import { getPageAnalytics, getTransactionAnalytics } from '@ynap/analytics'

export const trackPageEvent = (props) => ({
    ...getPageAnalytics({
        ...props.analytics,
        ...props.locale,
        pageName: 'checkout - sign in',
        primaryCategory: 'checkout',
    }),
    transaction: getTransactionAnalytics(props.checkoutAnalytics),
})

export const trackGuestCheckout = (maMarketingConsent, checkoutAnalytics) => {
    return {
        event: `guest checkout - ${maMarketingConsent === 'true' ? 'yes send me email' : "no don't send email"}`,
        eventEffect: 'checkout button',
        category: {
            primaryCategory: 'checkout',
            subCategory: 'sign in',
        },
        transaction: getTransactionAnalytics(checkoutAnalytics),
    }
}
export const trackLoggedInUserCheckout = (checkoutAnalytics) => ({
    event: 'proceed to checkout',
    eventEffect: 'checkout button',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'sign in',
    },
    transaction: getTransactionAnalytics(checkoutAnalytics),
})

export const trackLoggedInFailed = (checkoutAnalytics) => ({
    event: 'sign in - error',
    eventEffect: 'user experienced error',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'sign in',
    },
    transaction: getTransactionAnalytics(checkoutAnalytics),
})

export function trackRegistrationSuccess(checkoutAnalytics, maMarketingConsent) {
    return {
        event: `registration - successful - ${maMarketingConsent === 'true' ? 'yes send me email' : "no don't send email"}`,
        eventEffect: 'checkout button',
        category: {
            primaryCategory: 'checkout',
            subCategory: 'register',
        },
        transaction: getTransactionAnalytics(checkoutAnalytics),
    }
}

export function trackRegistrationFailed(checkoutAnalytics) {
    return {
        event: 'registration - error',
        eventEffect: 'user experienced error',
        category: {
            primaryCategory: 'checkout',
            subCategory: 'register',
        },
        transaction: getTransactionAnalytics(checkoutAnalytics),
    }
}

export function trackOptIn(checkoutAnalytics, marketingConsentValue, isGuestCheckout = false) {
    return {
        event: 'opt_in',
        opt_position: isGuestCheckout ? 'guest checkout' : 'sign up checkout',
        opt_value: marketingConsentValue,
        transaction: getTransactionAnalytics(checkoutAnalytics),
    }
}